export function parseEnvBooleanWithDefaultTrue(value?: boolean | null): boolean {
    if (value === null || value === undefined) return true;
    return value;
}
